import callable from './firebase-callable';

export function listUsers() {
  return callable('listUsers').get()
    .then(({ data: { members } }) => members);
};